import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCategoryApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getCategoryListApi = createAsyncThunk('getCategoryList', async (payload) => {
  return await getCategoryApi(payload);
});

const getCategoryListSlice = createSlice({
  name: 'getCategoryList', // Unique Name
  initialState,
  reducers: {
    getCategoryListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCategoryListApi.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getCategoryListApi.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getCategoryListApi.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getCategoryListReset } = getCategoryListSlice.actions;

export default getCategoryListSlice.reducer;
